import { useEffect, useState } from "react";
import AppAnimate from "../../../ui/AppAnimate/AppAnimate";
import {
  Box,
  createStyles,
  createTheme,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider,
  Tooltip,
  withStyles
} from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";
import { useStyles } from "../../../../shared/styles/useStyles";
import { CustomizedTableFooter } from "../../../custom/CustomizedTableFooter";
import { useDispatch, useSelector } from "react-redux";
import { CustomizedSearch } from "../../../custom/CustomizedSearch";

import { getAllCorrespondenceByVoided, getMilestonesV2, updateStateCorrespondence } from "../../../../services/firebase/correspondence";
import moment from "moment";
import RestoreIcon from '@material-ui/icons/Restore';
import ArtTrackIcon from '@material-ui/icons/ArtTrack';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CustomizedDialog from "../../../custom/CustomizedDialog";
import { MyAlert } from "../../../custom/MyAlert";
import { arraySearch } from "../../../../redux/actions/searchActions";
import { SearchV2Component } from "../../../ui/SearchV2Component";
import { ViewPDFComponent } from "../../../ui/ViewPDFComponent";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins",
    fontSize: 11,
  },
});

const StyledTableCell = withStyles((theme) =>
  createStyles({
    root: {
      whiteSpace: "nowrap",
    },
    head: {
      height: "40px",
    },
  })
)(TableCell);

export const Anulado = (props) => {
  /**
   * States here
   */
  const { user } = useSelector((state) => state.auth);
  const { page, rowsPerPage } = useSelector((state) => state.pagination);
  const classes = useStyles();
  const intl = useIntl();
  const [count, setCount] = useState();
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState([]);
  const [history, setHistory] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [successChange, setSuccessChange] = useState(false);
  const [showPDF, setShowPDF] = useState(false);
  const [viewDataPDF, setViewDataPDF] = useState();

  /**
   * Method here
   */
  const handleGetData = (idEntity) => {
    getAllCorrespondenceByVoided(idEntity).then((response) => {
      if (response.ok) {
        setData(response.data);
        setCount(response.data.length);
        setFilter(response.data);
      }
    })
  };

  const handleDataHistory = (entityId, correspondenceId) => {
    getMilestonesV2(entityId, correspondenceId).then((response) => {
      if (response.ok) {
        setShowHistory(true);
        setHistory(response.data);
      }
    });
  };

  const handleShowPDF = (entityId, correspondenceId) => {
    setShowPDF(true);
  };

  const handleRestore = (entityId, correspondenceId) => {
    let current = [];
    getMilestonesV2(entityId, correspondenceId).then((response) => {
      if (response.ok) {
        response.data.map((item, index) => {
          if (item.hasOwnProperty("oldState")) {
            current.push(item);
          }
        });
      }
      current = orderDate(current, "createAt");

      //console.log(" Restore old state: ", current);
      updateStateCorrespondence(
        entityId,
        correspondenceId,
        current[0].id,
        current[0].oldState)
        .then((response) => {
          if (response.ok) {
            setSuccessChange(true);
            handleDataHistory(entityId, correspondenceId);
          }
        });
    });

  };

  const handleClose = () => {
    setShowHistory(false);
    setSuccessChange(false);
  };

  const handleClosePDF = () => {
    setShowPDF(false);
    setViewDataPDF({});
  };

  const orderDate = (arr, key) => {
    return arr.sort((a, b) => b[key].toDate() - a[key].toDate());
  };

  /**
   * UseEffect here
   */
  useEffect(() => {
    if (user) {
      handleGetData(user.idEntity);
    }
    setCount(filter.length);
  }, [count, history, showHistory, page, rowsPerPage]);
  return (
    <AppAnimate animation={"transition.slideUpIn"} delay={200}>
      <Paper square className={classes.paper}>
        <Box mb={3} p={3} fontSize={20} style={{ width: "100%" }}>
          <Box container>
            <Box style={{ display: "flex", width: "100%" }}>
              <Box style={{ width: "70%" }}>

              </Box>

              <Box style={{ width: "30%" }}>
                <SearchV2Component data={data} fields={["id", "subject"]} setData={setFilter} />
              </Box>
            </Box>
            <Box style={{ width: "100%" }}>
              <Box mt={4}>
                <ThemeProvider theme={theme}>
                  <TableContainer component={Paper} className={classes.heightTable}>
                    <Table
                      className={classes.table}
                      size="small"
                      style={{ width: "100%" }}
                      aria-label="custom pagination table"
                    >
                      <TableHead className={classes.titleTable}>
                        <TableRow>
                          <StyledTableCell align="center" className={classes.titleTable}>
                            <FormattedMessage id="Settled" />{" "}
                          </StyledTableCell>
                          <StyledTableCell align="center" className={classes.titleTable}>
                            <FormattedMessage id="Subject" />{" "}
                          </StyledTableCell>
                          <StyledTableCell align="center" className={classes.titleTable}>
                            <FormattedMessage id="Voided" />{" "}
                          </StyledTableCell>
                          <StyledTableCell align="center" className={classes.titleTable}>
                            <FormattedMessage id="Date" />{" "}
                          </StyledTableCell>
                          <TableCell className={classes.titleTable} align="center">
                            <FormattedMessage id="Actions" />{" "}
                          </TableCell>

                        </TableRow>
                      </TableHead>
                      <TableBody style={{ tableLayout: "auto" }}>
                        {(rowsPerPage > 0 ? filter?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : filter
                        )?.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell align="center" >{row.id}</TableCell>
                            <TableCell align="center" >{row.subject}</TableCell>
                            <TableCell align="center" >{moment(row.createAt.toDate()).format("YYYY/MM/DD")}</TableCell>
                            <TableCell align="center" >{moment(row.createAt.toDate()).format("YYYY/MM/DD")}</TableCell>
                            <TableCell align="center" >
                              <Actions
                                entityId={user.idEntity}
                                correspondenceId={row.id}
                                restore={() => handleRestore(user.idEntity, row.id)}
                                history={() => handleDataHistory(user.idEntity, row.id)}
                              />
                            </TableCell>
                          </TableRow>
                        )
                        )}
                      </TableBody>
                      {/* --------- Footer para paginación -------- */}
                      <CustomizedTableFooter count={count} rowsPerPage={rowsPerPage} page={page} />
                    </Table>
                  </TableContainer>
                </ThemeProvider>
              </Box>
            </Box>
          </Box>
        </Box>

        <CustomizedDialog
          open={showHistory}
          cancelBtn={true}
          onDeny={handleClose}
          title={`${intl.formatMessage({ id: "History" })}`}
          content={<History data={history} viewDataPDF={setViewDataPDF} viewPdf={handleShowPDF} />}
          textButton="Accept"
        />

        <ViewPDFComponent
          data={viewDataPDF}
          open={showPDF}
          handleClose={handleClosePDF}
        />

        <MyAlert
          open={successChange}
          typeAlert="success"
          message="UpdatedCorrespondence"
          time={2000}
          handleClose={handleClose}
        />
      </Paper>
    </AppAnimate>
  );
};

const Actions = (props) => {
  /**
   * States here
   */
  const { entityId, correspondenceId, restore, history } = props;
  const intl = useIntl();

  /**
   * Method here
   */
  const handleRestore = () => {
    //console.log(" Restore id: ", correspondenceId);
    restore();
  };

  const handleHistory = () => {
    history();
  };

  /**
   * Effect here
   */
  useEffect(() => {
    //console.log("  CorrespondenceId: ", correspondenceId);
  }, []);
  return (
    <Box style={{ display: "flex", alignItems: "center", alignContent: "center", justifyContent: "center" }}>
      <Tooltip title={`${intl.formatMessage({ id: "Restore" })}`}>
        <IconButton aria-label="expand row" size="small" onClick={handleRestore}>
          {" "}
          <RestoreIcon />{" "}
        </IconButton>
      </Tooltip>
      <Tooltip title={`${intl.formatMessage({ id: "ShowHistory" })}`}>
        <IconButton aria-label="expand row" size="small" onClick={handleHistory}>
          {" "}
          <ArtTrackIcon />{" "}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

const History = (props) => {
  /**
   * States here
   */
  const { data, viewDataPDF, viewPdf } = props;
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const intl = useIntl();
  const [count, setCount] = useState(0);

  /**
   * Method here
   */
  const handleViewAct = (data) => {
    viewDataPDF(data.file);
    viewPdf();
  };

  const showViewAct = (value) => {
    if (value.hasOwnProperty("file")) {
      return (
        <Tooltip title={`${intl.formatMessage({ id: "ShowHistory" })}`}>
          <IconButton aria-label="expand row" size="small" onClick={() => handleViewAct(value)}>
            {" "}
            <VisibilityIcon />{" "}
          </IconButton>
        </Tooltip>
      );
    } else {
      return (<div> </div> );
    }
  };

  /**
   * Effect here
   */
  useEffect(() => {
    if (data) {
      setCount(data.length);
    }

  }, [count, data]);
  return (
    <Box style={{ width: "100%" }}>
      <Box mt={4}>
        <ThemeProvider theme={theme}>
          <TableContainer component={Paper} className={classes.heightTable}>
            <Table
              className={classes.table}
              size="small"
              style={{ width: "100%" }}
              aria-label="custom pagination table"
            >
              <TableHead className={classes.titleTable}>
                <TableRow>
                  <StyledTableCell align="center" className={classes.titleTable}>
                    <FormattedMessage id="annulled.number" />{" "}
                  </StyledTableCell>
                  <StyledTableCell align="center" className={classes.titleTable}>
                    <FormattedMessage id="PersonName" />{" "}
                  </StyledTableCell>
                  <StyledTableCell align="center" className={classes.titleTable}>
                    <FormattedMessage id="Date" />{" "}
                  </StyledTableCell>
                  <StyledTableCell align="center" className={classes.titleTable}>
                    <FormattedMessage id="Act" />{" "}
                  </StyledTableCell>
                  <StyledTableCell align="center" className={classes.titleTable}>
                    <FormattedMessage id="Process" />{" "}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ tableLayout: "auto" }}>
                {(rowsPerPage > 0 ? data?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data
                )?.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell align="center" >{index + 1}</TableCell>
                    <TableCell align="center" >{row.owner.name}</TableCell>
                    <TableCell align="center" >{moment(row.createAt.toDate()).format("YYYY/MM/DD")}</TableCell>
                    <TableCell align="center" >
                      {showViewAct(row)}
                    </TableCell>
                    <TableCell align="center" >{row.processName}</TableCell>
                  </TableRow>
                )
                )}
              </TableBody>
              {/* --------- Footer para paginación -------- */}
              <CustomizedTableFooter count={count} rowsPerPage={rowsPerPage} page={page} />
            </Table>
          </TableContainer>
        </ThemeProvider>
      </Box>
    </Box>
  );
};